import React, { useEffect, useState } from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

function ProgressBar({ percentage }) {
  return (
    <div className="relative flex items-center w-full h-5 bg-white rounded overflow-hidden">
      <div
        className="h-full rounded bg-blue-200"
        style={{ width: `${percentage}%`, backgroundColor: '#52248D' }}
      />
      <span className="absolute inset-0 flex px-5 w-full text-black text-sm font-medium">
        {percentage}%
      </span>
    </div>
  );
}

function Chart({candidates}) {

  return (
    <div className="w-80 mx-auto ">
      <div className="mt-4 space-y-4">
        {candidates.map(c => (
          <div key={c.name} className="flex items-center text-white justify-between ">
            <h2 className="text-lg font-medium w-64 ">{c.name}</h2>
            <ProgressBar percentage={c.percentage} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Chart;